module.exports = __webpack_public_path__ + "static/media/grid-item-c2.1ef4d7b0.png";